import { render, staticRenderFns } from "./NotificationRuleSetupModal.vue?vue&type=template&id=05b20753&scoped=true"
import script from "./NotificationRuleSetupModal.vue?vue&type=script&lang=ts"
export * from "./NotificationRuleSetupModal.vue?vue&type=script&lang=ts"
import style0 from "./NotificationRuleSetupModal.vue?vue&type=style&index=0&id=05b20753&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b20753",
  null
  
)

export default component.exports